<template>
    <v-container class="pa-2">
        <!-- Header sticky -->
        <v-card class="rounded-xl elevation-2 px-3 py-2 mb-3 sticky-header">
            <div class="d-flex align-center">
                <v-btn icon small text color="primary" @click="$emit('close')">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <div class="ml-2 flex-grow-1 text-subtitle-2 font-weight-bold primary--text">
                    Seleziona schema
                </div>
                <span class="text-caption grey--text mr-1">{{ filtrati.length }} schemi</span>
            </div>
            <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                placeholder="Cerca per numero o testo..."
                outlined rounded dense hide-details clearable
                autofocus
                class="mt-2"
            />
            <!-- Filtri attivi -->
            <div v-if="oratoreFiltro || congregazioneFiltro" class="d-flex flex-wrap mt-2" style="gap:6px">
                <v-chip v-if="oratoreFiltro" small color="primary" dark>
                    <v-icon x-small left>mdi-account-outline</v-icon>
                    {{ oratoreFiltro.nominativo }}
                </v-chip>
                <v-chip v-if="congregazioneFiltro" small color="teal" dark>
                    <v-icon x-small left>mdi-home-city-outline</v-icon>
                    {{ congregazioneFiltro.nome }}
                </v-chip>
            </div>
            <!-- Filtro solo non svolti (solo interno) -->
            <div v-if="isInterno" class="d-flex align-center mt-2">
                <span class="text-caption grey--text mr-1">Solo schemi non svolti nell'ultimo anno</span>
                <v-switch :input-value="soloSchemiNonSvolti" inset dense hide-details class="mt-0 pt-0"
                          @change="$emit('update:soloSchemiNonSvolti', $event)" />
            </div>
        </v-card>

        <!-- Skeleton -->
        <template v-if="loading">
            <v-card v-for="n in 6" :key="n" class="rounded-xl elevation-1 mb-2 px-3 py-2">
                <v-skeleton-loader type="list-item-two-line" />
            </v-card>
        </template>

        <!-- Lista -->
        <template v-else>
            <v-card
                v-for="item in filtrati"
                :key="item.discorso.id"
                class="rounded-xl elevation-1 mb-2 schema-card"
                @click="$emit('selected', item.discorso.id)"
            >
                <div class="d-flex align-center px-3 py-2">
                    <span class="numero-schema mr-3 flex-shrink-0">
                        {{ item.discorso.diId === 99999 ? '-' : (item.discorso.numero ? item.discorso.numero.trim() : item.discorso.diId) }}
                    </span>
                    <div class="flex-grow-1" style="min-width:0">
                        <div class="text-body-2">{{ item.discorso.tema }}</div>
                        <div v-if="item.ultimaData" class="text-caption grey--text mt-1 d-flex align-center">
                            <v-icon x-small class="mr-1" style="opacity:0.5">mdi-calendar-outline</v-icon>
                            {{ fmtData(item.ultimaData) }}
                            <span v-if="item.ultimoOratore" class="ml-1">· {{ item.ultimoOratore }}</span>
                        </div>
                    </div>
                    <v-icon color="grey lighten-1" size="18">mdi-chevron-right</v-icon>
                </div>
            </v-card>

            <div v-if="filtrati.length === 0" class="text-center grey--text py-10">
                <v-icon large color="grey lighten-1">mdi-book-open-outline</v-icon>
                <div class="mt-2 text-body-2">Nessuno schema trovato</div>
            </div>
        </template>
    </v-container>
</template>

<script>
import { VSkeletonLoader } from 'vuetify/lib';
import { gLocalData } from '@/modules/utilities.js';
export default {
    name: 'SelectSchema',
    components: { VSkeletonLoader },
    props: {
        items:               { type: Array,   default: () => [] },
        loading:             { type: Boolean, default: false },
        isInterno:           { type: Boolean, default: false },
        soloSchemiNonSvolti: { type: Boolean, default: true },
        oratoreFiltro:       { type: Object,  default: null },
        congregazioneFiltro: { type: Object,  default: null },
    },
    data: () => ({ search: '' }),
    computed: {
        filtrati() {
            let lista = this.items;
            if (this.search) {
                const s = this.search.toLowerCase();
                lista = lista.filter(item => {
                    const d = item.discorso || {};
                    const num = String(d.diId === 99999 ? '-' : (d.diId || '')).toLowerCase();
                    return num.includes(s) || (d.tema || '').toLowerCase().includes(s);
                });
            }
            return lista;
        },
    },
    methods: {
        fmtData(d) {
            if (!d) return '';
            return new Date(d).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
        },
    },
};
</script>

<style scoped>
.sticky-header { position: sticky; top: 0; z-index: 4; }
.schema-card { cursor: pointer; transition: box-shadow 0.15s; }
.schema-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.13) !important; }
.numero-schema {
    font-size: 0.72rem; font-weight: 700;
    padding: 2px 8px; border-radius: 6px;
    background-color: rgba(0,0,0,0.08);
    white-space: nowrap; min-width: 32px; text-align: center;
}
.theme--dark .numero-schema { background-color: rgba(255,255,255,0.12); }
</style>
